import { defineMessages } from 'react-intl'

export default defineMessages({
  spotCount: {
    id: 'containers.OrderPage.components.TaskPage.components.InlineMediaSelect.spotCount',
    defaultMessage: 'Spot Count',
  },
  airingTimeStart: {
    id: 'containers.OrderPage.components.TaskPage.components.InlineMediaSelect.airingTimeStart',
    defaultMessage: 'Airing start date',
  },
  mediaPlaceholder: {
    id: 'containers.OrderPage.components.TaskPage.components.InlineMediaSelect.mediaPlaceholder',
    defaultMessage: 'Media',
  },
  noMedia: {
    id: 'containers.OrderPage.components.TaskPage.components.InlineMediaSelect.noMedia',
    defaultMessage: 'No media selected. Add media from the dropdown above.',
  },
  delete: {
    id: 'containers.OrderPage.components.TaskPage.components.InlineMediaSelect.delete',
    defaultMessage: 'Delete',
  },
})
